import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";

export default function ChatbotReducer(state = InitialState.chatbot, action) {
  switch (action.type) {
    case types.SET_CHATBOT_EXTERNAL_DATA:
      return {
        ...state,
        externalData: action.payload,
      };

    case types.SET_BODHIBOT_ENABLED_STATUS:
      return {
        ...state,
        bodhibotStatusObj : action.payload,
      }

    default:
      return state;
  }
}



